import React, { Component } from "react";
import Footer from "./shared/Footer";
import LocalizedLink from "../containers/LocalizedLink";

import ImageAffairesEtrangeres_1 from "../images/realisations/projet_affaires-etrangeres/01_Ministeredesaffairesetrangeres.jpg";
import ImageAffairesEtrangeres_2 from "../images/realisations/projet_affaires-etrangeres/02_Ministeredesaffairesetrangeres.jpg";
import ImageAffairesEtrangeres_3 from "../images/realisations/projet_affaires-etrangeres/03_Ministeredesaffairesetrangeres.jpg";
import ImageAffairesEtrangeres_4 from "../images/realisations/projet_affaires-etrangeres/04_Ministeredesaffairesetrangeres.jpg";
import ImageAffairesEtrangeres_5 from "../images/realisations/projet_affaires-etrangeres/05_Ministeredesaffairesetrangeres.jpg";
import { patternsByIds } from "../constants/patterns";
import { surfacesByIds } from "../constants/surfaces";


class RealisationAffairesEtrangeres extends Component {
  render() {
    return (
      <React.Fragment>
        <section
          className="grid grid--2 grid--fixed"
          style={{ marginTop: "55px" }}
        >
          <LocalizedLink className="grid__item" to="/realisations">
            <div className="grid__item-title">
              <i className="f7 i-arrow-left-light" /> {this.props.t("common:realisationsBackbutton")}
            </div>
          </LocalizedLink>

          <div className="grid__item">
            <div className="grid__item-title-nohover font-bold">
              {this.props.t("realisations:ministryOfForeignAffairs")} - Paris
            </div>
          </div>
        </section>

        <section className="projects">
          <div
            className="projects__item projects__item--100"
            style={{ backgroundImage: `url(${ImageAffairesEtrangeres_1})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelArchitect")} : Arte - Charpentier
            </div>
          </div>

          <div
            className="projects__item projects__item--50"
            style={{ backgroundImage: `url(${ImageAffairesEtrangeres_2})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelArchitect")} : Arte - Charpentier
            </div>
          </div>
          <div
            className="projects__item projects__item--50 bl"
            style={{ backgroundImage: `url(${ImageAffairesEtrangeres_3})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelArchitect")} : Arte - Charpentier
            </div>
          </div>

          <div
            className="projects__item projects__item--50"
            style={{ backgroundImage: `url(${ImageAffairesEtrangeres_4})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelSurface")} : Oberflex - {surfacesByIds[13]["title_"+this.props.lng]}  {/*Chêne Naturel*/}
            </div>
          </div>
          <div
            className="projects__item projects__item--50 bl"
            style={{ backgroundImage: `url(${ImageAffairesEtrangeres_5})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelPattern")} : {this.props.t("common:labelClassics")} - {patternsByIds[3]["title_"+this.props.lng]}
            </div>
          </div>
        </section>


                <section className="w-100 pv7">
                  <div className="w-100 tc">
                    <LocalizedLink className="button button--large" to="/realisations/mgm-casino">
                      <i className="button__icon i-arrow-left-light" />
                      &nbsp;{this.props.t('common:labelPreviousProject')}
                    </LocalizedLink>

                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                    <LocalizedLink className="button button--large" to="/create">
                    {this.props.t('common:labelCreateYourModel')}&nbsp;
                      <i className="button__icon i-arrow-right-light" />
                    </LocalizedLink>


                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                    <LocalizedLink className="button button--large" to="/realisations/institution-internationale">
                      {this.props.t('common:labelNextProject')}&nbsp;
                      <i className="button__icon i-arrow-right-light" />
                    </LocalizedLink>
                  </div>
                </section>

          <Footer t={this.props.t} />
      </React.Fragment>
    );
  }
}

export default RealisationAffairesEtrangeres;



// WEBPACK FOOTER //
// ./src/components/RealisationAffairesEtrangeres.js